import AllowedDomainsInput from './AllowedDomains';
import { Logo } from './Logo';
import OrgId from './OrgId';

export default function General() {
  return (
    <div>
      <hr className="my-4" />
      <OrgId />
      <hr className="my-4" />
      <AllowedDomainsInput />
      <hr className="my-4" />
      <Logo />
    </div>
  );
}
